<div class="programare-vizita">
    <div ng-show="::ctrl.serviceTypes">
        <div class="servicii">
            <h3>Servicii Adi&#539;ionale</h3>
            <ul class="shop-services-list">
                <li ng-repeat="serviceType in ::ctrl.serviceTypes track by $index">
                    <a href="javascript:void(0);" ng-if="serviceType === 'care center'" class="carecenter" title="Care center" shop-tooltip></a>
                    <a href="javascript:void(0);" ng-if="serviceType === 'expert'" class="expert" title="Orange expert" shop-tooltip></a>
                    <a href="javascript:void(0);" ng-if="serviceType === 'plata factura'" class="bill" title="Plat&#259; factur&#259;" shop-tooltip></a>
                    <a href="javascript:void(0);" ng-if="serviceType === 'service'" class="service" title="Service" shop-tooltip></a>
                    <a href="javascript:void(0);" ng-if="serviceType === 'setari telefoane'" class="setaritel" title="Set&#259;ri telefoane" shop-tooltip></a>
                    <a href="javascript:void(0);" ng-if="serviceType === 'transfer de continut'" class="transfer" title="Transfer de con&#539;inut" shop-tooltip></a>
                    <a href="javascript:void(0);" ng-if="serviceType === 'wi-free'" class="wi-free" title="Wi-Free" shop-tooltip></a>
                </li>
            </ul>
        </div>
    </div>
    <div ng-show="::ctrl.paymentTypes">
        <h3>Op&#539;iuni de plat&#259;</h3>
        <ul>
            <li ng-repeat="paymentType in ::ctrl.paymentTypes track by $index">{{::paymentType}}</li>
        </ul>
    </div>
    <div ng-show="::ctrl.moneyTransferOptions">
        <h3>Transfer de bani</h3>
        <ul class="b">
            <li ng-repeat="moneyTransferOption in ::ctrl.moneyTransferOptions track by $index">{{::moneyTransferOption}}</li>
        </ul>
    </div>
</div>
